<app-wrapper>

  <div class="mb-9">
    <div class="mb-4">
      <div class="row g-3">
        <div class="col-auto">
          <h2>
            <div class="d-inline pe-2 cursor-pointer" (click)="back()" title="Назад">
              <i class="fa-solid fa-arrow-left"></i>
            </div>
            Категория "{{category.name}}"
          </h2>
        </div>
        <div class="col-auto flex-grow-1">
        </div>
        <div class="col-auto">
          <button (click)="save()" [disabled]="form.invalid || isBusy || isLoading" class="btn btn-primary">
            @if (isBusy) {
            <i class="fa-solid fa-spinner fa-spin me-2"></i>
            }
            @if (!isBusy) {
            <i class="fa-solid fa-save me-2"></i>
            }
            Сохранить
          </button>
        </div>
      </div>
    </div>

    <div class="row g-5">
      <div class="col-12">
        <form #form="ngForm" class="card p-4">
          <div class="row">
            <div class="col-12">
              <table class="w-100">
                <thead>
                  <tr>
                    <th>Название</th>
                    <th>Сортировка<br />
                      <span class="text-danger">
                        (для применения нажмите Enter)
                      </span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  @for (item of items; track item; let i = $index) {
                  <tr>
                    <td style="width: 50%;">
                      {{ item.name }}
                    </td>
                    <td>
                      <input type="number" min="0" step="1" [value]="item.order" style="max-width: 100px;"
                        (keyup.enter)="setValue(item, $event)" class="form-control mb-2">
                    </td>
                  </tr>
                  }
                </tbody>
              </table>
            </div>
          </div>
        </form>
      </div>
    </div>
    @if (isLoading) {
    <div class="overlay">
      <i class="fa-solid fa-spinner fa-spin fs-2"></i>
    </div>
    }
  </div>
</app-wrapper>